/* CCC Courier theme v1.3.1 — switch to the menu button when the menu links don't fit */
(function () {
  'use strict';
  function init() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var nav = header.querySelector('.site-nav');
    var list = header.querySelector('.site-nav__list');
    if (!nav || !list) return;
    function fit() {
      header.classList.remove('is-compact');
      if (getComputedStyle(nav).display === 'none') return;
      if (list.scrollWidth > nav.clientWidth + 1) header.classList.add('is-compact');
    }
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
